import { render, staticRenderFns } from "./PersonalizePackagingModal.vue?vue&type=template&id=216b0a59&scoped=true"
import script from "./PersonalizePackagingModal.vue?vue&type=script&lang=js"
export * from "./PersonalizePackagingModal.vue?vue&type=script&lang=js"
import style0 from "./PersonalizePackagingModal.vue?vue&type=style&index=0&id=216b0a59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b0a59",
  null
  
)

export default component.exports